module.exports = __webpack_public_path__ + "media/images/flags/64/French-Southern-Territories-2559326d7a4beb8b98731bed202bcfaf.png";